import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

const TOPOCARE_TAG_NAME = 'pxc-topocare';

@Injectable({ providedIn: 'root' })
export class TopocareLoaderService {
  private promise?: Promise<unknown>;
  private readonly platformId = inject(PLATFORM_ID);

  load(): Promise<unknown> {
    if (!isPlatformBrowser(this.platformId)) {
      console.warn('Not running in a browser environment, skipping Topocare loading.');
      return;
    }

    if (customElements.get(TOPOCARE_TAG_NAME)) {
      console.warn(`${TOPOCARE_TAG_NAME} is already defined, skipping Topocare loading.`);
      return;
    }

    if (customElements.get('pxc-topocare')) {
      return Promise.resolve(null);
    }

    if (this.promise) {
      return this.promise;
    }

    this.promise = import('@pixacare/topocare-web');
    return this.promise;
  }
}
